export default __webpack_public_path__ + "static/726-a7d1a95f6a81ea2563d9ae9bf60f4f2d.mp4";